enum ETypes {
  SET_SNIPPETS = 'SET_SNIPPETS',
  GET_SNIPPET = 'GET_SNIPPET',
  SET_NEW_SNIPPETS_ID = 'SET_NEW_SNIPPETS_ID'
}

export default ETypes;
